export default __webpack_public_path__ + "static/media/arrow.029b77d1.svg";